import { render } from "./callFollowUpTestFields.vue?vue&type=template&id=de14337e&scoped=true"
import script from "./callFollowUpTestFields.vue?vue&type=script&lang=js"
export * from "./callFollowUpTestFields.vue?vue&type=script&lang=js"

import "./callFollowUpTestFields.vue?vue&type=style&index=0&id=de14337e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de14337e"]])

export default __exports__